/**
 * Swipe gestures for the Today deck — pure math, unit-testable.
 *
 *   left  → "Later" (skip for this sitting; never written)
 *   right → open the question (options, context, items)
 *   up    → person tags
 * A gesture only counts when its dominant axis passes the threshold, so a
 * sloppy diagonal never decides anything.
 */

export const SWIPE_THRESHOLD = 80;

export type SwipeDir = "left" | "right" | "up" | null;

export function assessSwipe(dx: number, dy: number, threshold = SWIPE_THRESHOLD): SwipeDir {
  if (Math.abs(dx) < threshold && Math.abs(dy) < threshold) return null;
  if (Math.abs(dx) >= Math.abs(dy)) {
    if (dx >= threshold) return "right";
    if (dx <= -threshold) return "left";
    return null;
  }
  if (dy <= -threshold) return "up";
  return null; // downward is reserved (scroll)
}

/** Translate/rotation for the live drag feedback (iOS-like feel). */
export function dragFeedback(dx: number, dy: number): { x: number; y: number; rot: number; lift: number } {
  const rot = Math.max(-12, Math.min(12, dx / 14));
  const lift = Math.min(40, Math.abs(dx) / 6 + Math.max(0, -dy) / 4);
  return { x: dx, y: Math.min(0, dy * 0.6), rot, lift };
}
